/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const CheckmarkHeavy = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M21.1943 4.0517C21.3884 3.92353 21.6524 3.94529 21.8232 4.11615L22.8838 5.1767C22.9775 5.27044 23.0302 5.39764 23.0303 5.53021C23.0303 5.66282 22.9776 5.78996 22.8838 5.88373L9.35352 19.414C9.15825 19.6093 8.84175 19.6093 8.64648 19.414L1.11621 11.8837C0.921006 11.6885 0.920968 11.3719 1.11621 11.1767L2.17676 10.1161L2.25293 10.0536C2.33445 9.99928 2.43085 9.96969 2.53027 9.96967C2.66285 9.96967 2.79003 10.0224 2.88379 10.1161L9 16.2324L21.1162 4.11615L21.1943 4.0517Z"
                        fill={color}
                        stroke={color}
                        strokeLinejoin="round"
                    />
                </svg>
        );
    };
